import { SortOptionEnum, SortOption } from '../components/sort-options/types';
import {
  PRICE_SHIPPING_SORT,
  PRODUCT_VARIANT_SELECTED,
  PRICE_GROUPING,
} from '../actions/product';
import { Variant } from '../../../types';
import {
  GroupOption,
  GroupOptionEnum,
} from '../components/price-list/group-options/types';

type State =
  | {
      campaigns: any[] | null;
      sort: SortOption;
      grouping: GroupOption;
      variant: Variant;
    }
  | undefined;

type Action =
  | {
      type: 'PRICE_SHIPPING_SORT';
      sort: SortOption;
    }
  | {
      type: 'PRODUCT_VARIANT_SELECTED';
      variant: Variant;
    }
  | {
      type: 'CAMPAIGNS_RECEIVE';
      campaigns: any[] | null;
    }
  | {
      type: 'PRICE_GROUPING';
      grouping: GroupOption;
    };

export default (state: State, action: Action) => {
  if (!state) {
    // variant.id === 0 corresponds to "all", which is set to default selected value here
    return {
      campaigns: null,
      variant: { id: 0 },
      sort: SortOptionEnum.PRICE,
      grouping: GroupOptionEnum.GROUP_ON_PARTNERS,
    };
  }

  switch (action.type) {
    case 'CAMPAIGNS_RECEIVE': {
      return {
        ...state,
        campaigns:
          action.campaigns &&
          action.campaigns.filter(campaign => campaign.state === 'ACTIVE'),
      };
    }

    case PRICE_SHIPPING_SORT: {
      return {
        ...state,
        sort: action.sort,
      };
    }

    case PRODUCT_VARIANT_SELECTED: {
      return {
        ...state,
        variant: action.variant,
      };
    }

    case PRICE_GROUPING: {
      return {
        ...state,
        grouping: action.grouping,
      };
    }

    default:
      return state;
  }
};
